module.exports = __webpack_public_path__ + "3e5d30568125f260033adddccb111fef.svg";